import buttonsStyles from './buttonsStyles'
import formsStyles from './formsStyles'

export const useButtonsStyles = buttonsStyles
export const useFormsStyles = formsStyles
